export enum ToggleButtonsColor {
  LIGHT = 'light',
  DARK = 'dark',
}

export interface ToggleOption {
  value: string;
  option: string;
}
